<label *ngIf="label" [attr.for]="id">{{ label }}<itm-required *ngIf="validators?.required"></itm-required><button
		type="button" class="ml-2 pointer btn btn-outline-primary {{ cssLabelAction }}" (click)="_labelActionClick($event)"
		*ngIf="labelAction">{{ labelAction
		}}</button></label>
<div class="input-group" *ngIf="inputGroupLabel">
	<div class="input-group-prepend">
		<span class="input-group-text">{{ inputGroupLabel }}</span>
	</div>
	<input [attr.id]="id" class="form-control {{ cssClass }}" (input)="onChange($event.target.value)" (blur)="onTouched()"
		[type]="type" [disabled]="disabled" [placeholder]="placeholder" autocomplete="off" #controlRef2 [value]="val">
</div>
<ng-container *ngIf="!inputGroupLabel">
	<input [attr.id]="id" class="form-control {{ cssClass }}" (input)="onChange($event.target.value)" (blur)="onTouched()"
		[type]="type" [disabled]="disabled" [placeholder]="placeholder" autocomplete="off" #controlRef [value]="val">
</ng-container>
<small *ngIf="showValidationMessage()" class="text-danger">
	<ng-content></ng-content>
</small>